import React, {useEffect, useState} from 'react'
import {useStateContext} from '../context/StateContext';
import {ListaNonConformita, TextHighlight, AddButton, NewDeviceField, CheckIcon, UserIcon, BackButton, VisDiv, Photos, Comments,Loading, ViewLabelValueField, FieldDropdown, Divider} from '../components';
import deadlines from '../components/Deadlines';
import { userLogCheck, floor, findKey, addLogToDoc, deviceSubstitutionStatus, objectIsObject, unique, listOptions } from '../lib/utils'; 
import { ViewEditPresidio, ViewEditFields, } from '../components/frontend_components/ViewAndEdit';
import { v4 as uuidv4, v4 } from 'uuid';
import { expandReference, updateDevices,  keyId, sortByArrayElement, } from '../lib/utils';
import {FiEdit, FiMapPin, FiInfo } from 'react-icons/fi'
import Swal from "sweetalert2"
import { successAlert, errorAlert, deviceLogsExpanded, gMapLink } from '../lib/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { logDoc, referenceDoc } from '../components/gestioneDatabase/Docs';
import AddNonConformity from './add-non-conformity';
import NonConformity from './non-conformity';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { useOfflineContext } from '../context/OfflineContext';
import { facilityClient, isGodMode, clientUser } from '../lib/userPermissions';
import {TextField} from '../components';
import { trackDoc } from '../components/RegisterTemplateData';
import { postingEmail } from '../components/NodeMailer';
import { usePreventScroll } from 'react-aria';
import ScanQrCode from '../components/ScanQrCode';
import { MdOutlineQrCodeScanner } from "react-icons/md";
import { useAuthContext } from '../hooks/useAuthContext';
import { _FETCH } from '../lib/patches';
import TestButton from '../components/frontend_components/TestButton';
import { duplicateDeviceFn } from '../components/management/DuplicateDeviceFn';
import { AiTwotoneDelete } from 'react-icons/ai';
import PromiseQueue from 'p-queue'




/**
 * Main component for managing devices in the registers system.
 * Handles device creation, editing, substitution, archival and maintenance operations.
 * #devices
 * #registersDevicesNonConformitiesModule
 * 
 * @param {Object} data Configuration object containing required data
 * @param {Object} data.client Client information including revision status
 * @param {Array} data.registers Array of register objects containing devices
 * @param {Array} data.customerUsers Array of customer user objects
 * @param {Object} data.site Site information
 * @param {Object} data.currentTemplate Template containing device configurations
 * @param {Array} data.devices Array of device objects
 * @param {Array} [data.subReasons] Array of substitution reason options
 * @param {Array} [data.nonConformities] Array of non-conformity objects
 * @param {boolean} [data.hideBackButton] Whether to hide the back button
 * @returns {JSX.Element} Device management interface
 */

/**
 * Component for adding and editing devices
 * Handles device creation, editing, QR code management, and offline synchronization
 * 
 * @param {Object} props Component props
 * @param {boolean} props.qrCheck Whether QR code check is active
 * @param {Function} props.setQrCheck Function to set QR check state
 * @param {Object} props.register Current register object containing device data
 * @param {Object} props.device Device object being edited (undefined for new devices)
 * @param {Object} props.data Additional configuration data including client, templates, etc.
 * @param {Function} props.offlineFn Function to handle offline operations
 * @param {Function} props.replaceDevice Function to replace/update device in register
 * @param {Function} props.updateRegister Function to update entire register
 * @param {Function} props.addToArray Function to add new items to arrays
 * @returns {JSX.Element} Device management interface with forms, validation, and controls
 */
const AddNewDevice = ({qrCheck, setQrCheck=()=>{}, register, device, data={}, offlineFn=()=>{}, replaceDevice=()=>{}, updateRegister=()=>{}, addToArray=()=>{}}) => {
    
    // CONTEXT
    const {sUser, LDB, modalOpen, deviceIndexPage, sites, loading, setLoading, setDeviceIndexPage, setRegisters, setRegister, setIndexPage, setCurrentDevice, deviceEdit, setDeviceEdit, setDevices, duplicateDevice, setDuplicateDevice} = useStateContext();
        const {
            offlineData,
            failedDevicesQueryDocs,
            setOfflineData,
            bypassOffline,
            setFailedDevicesQueryDocs,
        } = useOfflineContext()

    usePreventScroll({isDisabled: !modalOpen})

    const { user } = useAuthContext()
    const fetchRoute = `${useStateContext()?.apiUrl}/calls/fetch-docs`
    const subReasons = data?.subReasons ? data?.subReasons: useStateContext()?.subReasons
    const client = data?.client ? data?.client: useStateContext()?.client
    const registers = data?.registers ? data?.registers: useStateContext()?.registers
    const customerUsers = data?.customerUsers ? data?.customerUsers: useStateContext()?.customerUsers
    const site = data?.site ? data?.site: useStateContext()?.site
    const currentTemplate = data?.currentTemplate ? data?.currentTemplate: useStateContext()?.currentTemplate
    const devices = data?.devices ? data?.devices: useStateContext()?.devices
    const nonConformities = data?.nonConformities ? data?.nonConformities: useStateContext()?.nonConformities

    const language = sUser?.language
    //const dataConsole = () => console.log( {sUser, LDB, subReasons, deviceIndexPage, loading, setLoading, client, setDeviceIndexPage, setRegisters, registers, setRegister, customerUsers, setIndexPage, site, currentTemplate, setCurrentDevice, deviceEdit, setDeviceEdit, devices, setDevices, duplicateDevice})
    
    //#deadlines
    const deviceDeadlines = deadlines(device, currentTemplate) ? deadlines(device, currentTemplate) : {}

    const queryClient = useQueryClient()
    const P =  "device"
    const networkStatus = useNetworkStatus()
    const deviceLogs = device?.userLog ? device?.userLog : []
    const expandedDevice = {...objectIsObject(device), userLog: deviceLogsExpanded(deviceLogs, customerUsers)}

    const [deviceFields, setDeviceFields] = useState([])
    const [dateFields, setDateFields] = useState([])
    const [currentLocation, setCurrentLocation] = useState([])
    const [nonConformitiesToDuplicate, setNonConformitiesToDuplicate] = useState([])
    //const [loading, setLoading] = useState(false);
    const [currentTemplateDevice, setCurrentTemplateDevice] = useState(undefined)
    const [substituteDevice, setSubstituteDevice] = useState(undefined)
    const [substituteDeviceFields, setSubstituteDeviceFields] = useState([])
    const [substituteReason, setSubstituteReason] = useState(undefined)
    const [checkStatus, setCheckStatus] = useState(undefined)
    const [nTimes, setNTimes] = useState(2)
    //#deadlines
    const [expiryDeadline, setExpiryDeadline] = useState(deviceDeadlines )
    const [deviceStatus, setDeviceStatus] = useState(deviceSubstitutionStatus({deviceStatus: device?.status, deadlines: deviceDeadlines, device, client}))
    //#doneCheck
    const [doneBy, setDoneBy] = useState()
    //const [doneBy, setDoneBy] = useState(userLogCheck(expandedDevice))
    const [trackedChanges, setTrackedChanges] = useState([])
    const [subTrackedChanges, setSubTrackedChanges] = useState([])
    const [isSubstituting, setIsSubstituting] = useState(false)
    const [changingPresidio, setChangingPresidio] = useState(false)
    const [innerErrorFound, setInnerErrorFound] = useState(false)

    
    //const router = useRouter()

    //const substitutionStatus = deviceSubstitutionStatus(deviceStatus, expiryDeadline, client)
    const substitutionStatus = deviceStatus
    const statusTranslation = (statusString) => {
        if(statusString == "ATTIVO") return LDB(P,"active")
        if(statusString == "DA SOSTITUIRE") return LDB(P,"toSubstitute")
        if(statusString == "DA FORNIRE") return LDB(P,"toSupply")
        return statusString
    }
    
    /**
     * @param {*} deviceStatus the state that takes the curent device status
     * @param {*} expiryDeadline the expiry date in years of the device
     * @param {*} bypassDeviceStatus boolean: to use only if checking status of the expiration, or else it blocks the button action
     * @param {*} customDate year (2004): if I want to check substitution on a year different than the current one 
     * @returns "ATTIVO" or "DA SOSTITUIRE" status
     */

  
    /**
     * Duplicates a device with new position if auto-positioning is enabled
     * #doneCheck
     * #duplicateDevice
     * @param {Object} params Function parameters
     * @param {Object} params.device Device to duplicate
     * @param {Object} params.client Client information
     * @param {Object} params.currentTemplate Current register template
     * @param {Object} params.register Current register
     * @param {Array} params.allPositions Array of existing positions
     * @param {Function} params.setDateFields State setter for date fields
     * @param {Function} params.setCurrentLocation State setter for location
     * @param {Function} params.setSubstituteDevice State setter for substitute device
     * @param {Function} params.setSubstituteDeviceFields State setter for substitute fields
     * @param {Function} params.setSubstituteReason State setter for substitution reason
     * @param {Function} params.setDeviceFields State setter for device fields
     * @param {Function} params.setDeviceStatus State setter for device status
     **/


    useEffect(()=>{
        //console.log("jksdnklajndl triggered useEffect in device.js")
        
        if (device?._id){
            const expiry = deadlines(device, currentTemplate) 
            setCurrentTemplateDevice(expandReference(device?.templateDevice, currentTemplate.devices))
            if(!duplicateDevice){
                setSubstituteDevice(expandReference(device?.substituteDevice, currentTemplate.devices))
                setSubstituteDeviceFields(device?.substituteFields)
                setSubstituteReason({...objectIsObject(device?.substituteReason), value: device?.substituteReason?.label})
                //console.log("laxlkamsxklasmxk", {expiry, status: device.status, substituteReason: device?.substituteReason})
                setDeviceStatus(deviceSubstitutionStatus({ deviceStatus: device?.status, deadlines: expiry, device, client}))
                setDeviceFields(device?.fields)
                setDateFields(device?.dates)
                setCurrentLocation (device?.locations)
                setNonConformitiesToDuplicate([])
            }
            if (duplicateDevice){
                const positions = positionsString()
                const allPositions = positions?.allpositions
                duplicateDeviceFn(
                    {device, client, currentTemplate, register, allPositions, setDateFields, setCurrentLocation, setSubstituteDevice, setSubstituteDeviceFields, setSubstituteReason, setDeviceFields, setDeviceStatus},
                    (deviceNonConformities)=>{setNonConformitiesToDuplicate(deviceNonConformities);}
                )
            }
            const lastCheckDate = userLogCheck(device)?.date
            setDoneBy(userLogCheck(expandedDevice))
            if(lastCheckDate && !duplicateDevice) {
                //#doneCheck
                const now = Date.now()
                const passedMills = now - lastCheckDate
                const checkResetDays = register?.checkResetDays ? register?.checkResetDays : 120
                const nMonths = 1000 * 60 * 60 * 24 * checkResetDays
                if(passedMills < nMonths){setCheckStatus("FATTO") }
                else {setCheckStatus("DA FARE")}   
            }
            if(!lastCheckDate && !duplicateDevice){
                setCheckStatus("DA FARE")
            }
        } else
        {
            //console.log("DEVICE qwiuhdiuqwhdiuqwhd", currentTemplateDevice)
            // Reset all state for new device
            setCurrentTemplateDevice(undefined)
            setSubstituteDevice(undefined)
            setSubstituteDeviceFields([])
            setSubstituteReason(undefined)
            setDeviceStatus("ATTIVO")
            setDeviceFields([])
            setDateFields([])
            setCurrentLocation([])
            setNonConformitiesToDuplicate([])
            setCheckStatus(undefined)
            setTrackedChanges([])
            setSubTrackedChanges([])
        }

    },[device?._id, device, duplicateDevice, currentTemplate])

    /**
     * Checks if the device should be substituted based on the deadline type and client revision
     * #substituteDevice
     * @returns {boolean} true if the device should be substituted, false otherwise
     */
    const activateSubstitutionFromDeadlineType = () => {
       const data = expiryDeadline?.data
       const deadlineType = expiryDeadline?.deadlineType
        const isScadenzaCollaudoRevisione = !!deadlineType == "Scadenza-Collaudo-Revisione"
        const isSubMaintenance = data?.some?.((x)=>x?.deadlineSubstitutionIfClientRevisionFalse)
        const isClientRevision = client?.revision

        if(isScadenzaCollaudoRevisione && isSubMaintenance && !isClientRevision) return true
        return false
    }


//==========================================DEVICE SUBSTITUTION=============================================================================
   
    const allNonConformities = device?.nonConformities ? device?.nonConformities : []

    const templateProductionField = !Array.isArray(currentTemplate?.dates) ? undefined : currentTemplate?.dates?.find?.(x=>x?.dateType=="production")
    //SAME AS CURRENT DATE DOCS 
    const currentDateinField = (templateField) => {
        
        //const yearsList = templateField?.lists?.find?.(z=>z?.listName == "ANNI")
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth()
        //const thisYearObject = yearsList?.fieldList?.find?.(y => y?.label == currentYear)
        const dateField = {
            _key: keyId(), 
            values:[{
                dateObject:{
                    year: currentYear,
                    month: currentMonth + 1 
                },
                value: currentYear?.toString(),
                 _key: keyId() }], 
            templateField: {_type: "reference", _ref:templateField?._id, _key: keyId()}
        }
        return dateField
    }

    const substituteFieldsProperties = !Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields?.filter?.(x=>x?.substitution)
    
    //EXISTING UNMODIFIED FIELDS PLUS SUBSTITUTION FIELDS SELECTED #substituteDevice
    const substituteNewDeviceFields = () => {
        const templateFields = currentTemplate?.fields ? currentTemplate?.fields : []
        const duplicateFields = !Array.isArray(currentTemplate?.duplicateFields) ? [] : 
            currentTemplate?.duplicateFields?.map?.((x)=> 
                !Array.isArray(templateFields) ? undefined : templateFields?.find?.((y)=>x?._ref == y?._id)
        )
        //console.log("IN CONSOLE subs duplicate:", duplicateFields, "template", templateFields )
        const existingFieldsToCopy = !Array.isArray(duplicateFields) ? [] : duplicateFields?.map?.(item=>{
            const fieldInDevice = !Array.isArray(device?.fields) ? undefined : device?.fields?.find?.(x=>item?._id == x?.templateField?._ref)
            return fieldInDevice
        })
        const subFields = Array.isArray(substituteDeviceFields) ? substituteDeviceFields : []
        return [
            ...subFields, 
            //...existingFieldsToCopy?.filter?.((x)=>x),
            ...existingFieldsToCopy?.filter?.((x)=>x).filter?.((y)=>!subFields?.some?.(z=>z?.templateField?._ref == y?.templateField?._ref))
            ]?.filter?.((y)=>y)
    }

    const substituteDeviceTemplate = expandReference(device?.substituteDevice, currentTemplate?.devices)
    const nonConfToTransfer = !Array.isArray(allNonConformities) ? [] : allNonConformities?.filter?.(x=>x?.status =="DA FARE")

    const docId = device?._id && !duplicateDevice ? device._id : uuidv4()
    
    const nonConfDoc = (item) => ( {
        postedBy: [{ _type: 'postedBy', _ref: sUser?._id, _key: keyId(), }], 
        status:"DA FARE",
        createdOn: Date.now(),
        _key:  keyId(),
        _id:  uuidv4(),
        _type: "deviceNonConformity",
        nNonConformities:"1",
        nonConformity:{
            _ref: item?._id ? item?._id : item?._ref,
            _type: "reference",
            _key: keyId(),
        },
        comments:[],
        image:[]

    })

    //======================================= Min-Max =============================================//

    const minMaxFieldsTemplate = !Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields
    ?.filter?.((x)=>x.fieldType=="minMax" && deviceFields?.some?.((y)=>x._id == y?.templateField._ref))
    ?.map?.((item)=>{
        return item}) 

    const minMaxFields = !Array.isArray(deviceFields) ? [] : deviceFields
    ?.filter?.((y)=> !Array.isArray(minMaxFieldsTemplate) ? false : minMaxFieldsTemplate?.some?.((x)=> x?._id == y?.templateField?._ref ))
    ?.map?.((item)=>(
        {template: minMaxFieldsTemplate?.find?.((x)=> x?._id == item?.templateField?._ref ),
        fieldValue: item?.values?.[0]?.value}
    ))

    const minMaxNonConformities = !Array.isArray(minMaxFields) ? [] : minMaxFields.map?.((item)=>{
       //console.log("lkaewnkalwjnerv", minMaxFields,  item?.fieldValue)
        const isZero = Number(item?.fieldValue) === 0
        const isMore = Number(item?.fieldValue) > Number(item?.template?.maxValue)
        const isLess = Number(item?.fieldValue) < Number(item?.template?.minValue)

        if (isZero && item?.template.zeroNonConformity ){
            //console.log("ljkwdnclwnc")
            return nonConfDoc(item?.template?.zeroNonConformity)}
        //if(!item?.fieldValue){ return undefined}
        //if(!Number(item?.fieldValue)) { return undefined}
        if (isMore){return nonConfDoc(item?.template?.maxNonConformity)}
        if (isLess){return nonConfDoc(item?.template?.minNonConformity)}
    })?.filter?.((z)=> z )

    
   //================================ MAINTENANCE DATA ===========================================================================
   const maintenanceData = () => {
    //#deadlines
    const data = deviceDeadlines?.data
    return data
    }


    //=================================== GENERATED NON CONF ===========================================================================
    //#deviceNonConformities

     const generatedNonConformities = !Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields
            ?.filter?.((x)=>x.fieldGeneratedNonConformity && deviceFields
                ?.some?.((y)=>x._id == y?.templateField._ref))
            ?.map?.((item)=>item?.nonConformities)
            ?.flat(1)?.filter?.((z)=>z)

    
    const generatedNonConformitiesDevice = Array.isArray(generatedNonConformities) ? 
    generatedNonConformities?.map?.((item)=>(nonConfDoc(item))) : []

    const existingNonConformities = !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities
    const activeExistingNonConformities = existingNonConformities?.filter?.((x)=>x?.status !== "ARCHIVIATO" && x?.status !== "COMPLETATO")
    const nonConformitiesToSave = [
        ...!Array.isArray(generatedNonConformitiesDevice) ? [] : generatedNonConformitiesDevice,
        ...!Array.isArray(minMaxNonConformities) ? [] : minMaxNonConformities,
    ]
            ?.filter?.((x)=>!activeExistingNonConformities?.some?.((y)=>y?.nonConformity?._ref == x?.nonConformity?._ref))

    //console.log("to save",nonConformitiesToSave, "existing",activeExistingNonConformities )

    // ============================================ DOCS ==============================================
    
    /**
     * Creates a doc with a reference to the substitute device
     * Used when the device status is "DA SOSTITUIRE" and the substitute device exists
     * #substituteDevice
     * @returns {Object} A doc with a reference to the substitute device
     */
    const substituteDeviceDoc = () => {
        //console.log("substituteDeviceDoc", substituteDevice)
        if(deviceStatus == "DA SOSTITUIRE" && substituteDevice?._id) return ({
            _type: 'reference',
            _ref:  substituteDevice?._id,
            _key: keyId(),
            })
        return undefined
    }
    const historyDoc = {
        _id: keyId(),
        _key: keyId(),
        _type:"device",
        templateDevice: {
            _type: 'reference',
            _ref: currentTemplateDevice?._id,
            _key: keyId(),
            },
        substituteDevice: substituteDeviceDoc(),
        substituteReason: substituteReason,
        label: currentTemplateDevice?.label,
        locations: currentLocation,
        fields: deviceFields,
        substituteFields: substituteDeviceFields,
        dates: dateFields,
        status: substitutionStatus ? substitutionStatus:"ATTIVO",
        trackingList:[
            ...!Array.isArray(trackedChanges) ? [] : trackedChanges, 
            ...!Array.isArray(subTrackedChanges) ? [] : subTrackedChanges
        ]
    }



    const newDoc = {
        _id: docId,
        _key: keyId(),
        _type:"device",
        templateDevice: {
            _type: 'reference',
            _ref: currentTemplateDevice?._id,
            _key: keyId(),
            },
        substituteDevice: substituteDeviceDoc(),
        substituteReason: substituteReason,
        label: currentTemplateDevice?.label,
        locations: currentLocation,
        fields: deviceFields,
        substituteFields: substituteDeviceFields,
        dates: dateFields,
        status: substitutionStatus ? substitutionStatus:"ATTIVO",
        nonConformities: [...nonConformitiesToSave,  ...!Array.isArray(nonConformitiesToDuplicate) ? [] : nonConformitiesToDuplicate],
    }
   
    const updateDoc = {
        ...objectIsObject(device),
        templateDevice: {
            _type: 'reference',
            _ref: currentTemplateDevice?._id
            },
        substituteDevice: substituteDeviceDoc(),
        substituteReason: substituteReason,
        label: currentTemplateDevice?.label,
        locations: currentLocation,
        fields: deviceFields,
        substituteFields: substituteDeviceFields,
        dates: dateFields,
        status: substitutionStatus ? substitutionStatus:"ATTIVO",
        nonConformities: [
            ...!Array.isArray(nonConformitiesToSave) ? [] : nonConformitiesToSave,
            ...!Array.isArray(existingNonConformities) ? [] : existingNonConformities],
    }

    //substituteDevice
    const substituteDoc = {
        _id: uuidv4(),
        _key: keyId(),
        _type:"device",
        templateDevice: {
            _type: 'reference',
            _ref: device?.substituteDevice?._ref ? device?.substituteDevice?._ref : device?.templateDevice?._ref,
            _key: keyId(),
            },
        label: substituteDeviceTemplate?.label ? substituteDeviceTemplate?.label : device?.label,
        locations: device?.locations,
        fields: unique("_key", substituteNewDeviceFields()),
        dates: [currentDateinField(templateProductionField)],
        status: "ATTIVO",
        nonConformities: nonConfToTransfer
    }

    //USE EFFECT CHANGE OF DATE MAKES IT EXPIRED
    //#substituteDevice
    useEffect(()=>{
        console.log("CHANGING PRESIDIO FIRST kledmlwkemdlkwe")
        if(changingPresidio ){
            const newSubstituteFields = !Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields?.filter?.(x=>x?.substitution && x?.substitutionDefaultValue).map?.(item=>{
                const findDeviceInFields = !Array.isArray(deviceFields) ? undefined : deviceFields?.find?.(x=>x?.templateField?._ref == item?._id)
                //console.log("DEDEED", findDeviceField, findDeviceFieldInNewDoc )
                return (findDeviceInFields)
                
            })
               console.log("CHANGING PRESIDIO IS TRUE", {defaultSubstituteFields, newSubstituteFields, currentTemplateDevice})
               //setSubstituteDeviceFields(newSubstituteFields)
               //setSubstituteDevice(currentTemplateDevice)
               setChangingPresidio(false)
        }
    }, [changingPresidio])
    
    //#deviceFields
    useEffect(()=>{
            //console.log("lajdloqjdliwqdj", {deviceDeadlines, substitutionStatus, status: deviceSubstitutionStatus({deviceStatus, deadlines:deadlines(updateDoc, device, currentTemplate), client, bypassDeviceStatus: true}), deviceStatus, updateDoc })
            if(deviceEdit){
            const expiryField = !Array.isArray(subReasons) ? undefined : subReasons?.find?.((x)=>x?.label == "SCADUTO")
            const expiryDeadlines = deadlines(updateDoc, currentTemplate)
            const newDeviceStatus = deviceSubstitutionStatus({deviceStatus, device, deadlines: expiryDeadlines, client, bypassDeviceStatus:true})
            //const expiryReason = expiry?.data[0]?.label
            //console.log("date use effect", {expiry: expiryDeadlines, newDeviceStatus})
            if(newDeviceStatus == "ATTIVO"){
                //console.log("qpowskpqwkspwoks ATTIVO")
                setExpiryDeadline(undefined)
                setSubstituteDeviceFields([])
                setSubstituteReason({})
                setDeviceStatus(newDeviceStatus)
            } else {
            //console.log("jdqwehjdiwluedj NON ATTIVO")
            setExpiryDeadline(expiryDeadlines)
            setDeviceStatus(newDeviceStatus)
            //setSubstituteDeviceFields(defaultSubstituteFields)
            //setSubstituteReason(expiryField)
        }
    }

   
    },[dateFields])


    const editingToggle = () => {
        setDeviceEdit(!deviceEdit)
    }

//===================================== FUNCTIONS THAT MAKE THE DEVICE DOC TO SUPPLY OR TO SUB ===========================================
// #supplyDevice #substituteDevice

const subColor = substitutionStatus == "DA SOSTITUIRE" ? "blue": "grey"
const supplyColor = substitutionStatus == "DA FORNIRE" ? "blue": "grey"

const supply = () => {
    if(substitutionStatus == "DA FORNIRE"){
        setDeviceStatus("ATTIVO")
        const trackData = {trackedChanges: subTrackedChanges, updatedValue: "ATTIVO", oldDoc: device?.status, fieldName:"STATUS"}
        trackDoc(trackData, setSubTrackedChanges)
    }
    else {
        setDeviceStatus("DA FORNIRE")
        const trackData = {trackedChanges: subTrackedChanges, updatedValue: "DA FORNIRE", oldDoc: device?.status, fieldName:"STATUS"}
        trackDoc(trackData, setSubTrackedChanges)
    }
}

const defaultSubstituteFields = !Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields?.filter?.(x=>x?.substitution && x?.substitutionDefaultValue).map?.(item=>{
    const findDeviceField = !Array.isArray(device?.fields) ? undefined : device?.fields?.find?.(x=>x?.templateField?._ref == item?._id)
    
    const findDeviceFieldInNewDoc = !Array.isArray(newDoc?.fields) ? undefined : newDoc?.fields?.find?.(x=>x?.templateField?._ref == item?._id)
    //console.log("DEDEED", findDeviceField, findDeviceFieldInNewDoc )
    if(findDeviceField)return (findDeviceField)
    else return (findDeviceFieldInNewDoc)
    
})

const substitute = () => {
    
    if(substitutionStatus == "DA SOSTITUIRE") {
        setDeviceStatus("ATTIVO")
        setSubstituteDevice(undefined)
        setSubstituteDeviceFields([])
        setSubstituteReason({})
        //console.log("substitute button")
        const trackData = {trackedChanges: subTrackedChanges, updatedValue: "ATTIVO", oldDoc: device?.status, fieldName:"STATUS"}
        trackDoc(trackData, setSubTrackedChanges)
    }
    else {
        setDeviceStatus("DA SOSTITUIRE")
        const trackData = {trackedChanges: subTrackedChanges, updatedValue: "DA SOSTITUIRE", oldDoc: device?.status, fieldName:"STATUS"}
        trackDoc(trackData, setSubTrackedChanges)
        //console.log("substitute button else", substituteDevice, currentTemplateDevice, defaultSubstituteFields)
        if(!substituteDevice){
            //setSubstituteDevice(currentTemplateDevice)
            //setSubstituteDeviceFields(defaultSubstituteFields)
        }
    }
}
//=============================================================================================================
 //--------------------------------unique fields ---------------------------------------
 // #deviceFields
    
    // all fields in current device that we are currently editing
    const checkDoc = !device ? newDoc : updateDoc
    const allFieldsInDoc = [
        ...!Array.isArray(checkDoc?.locations) ? [] : checkDoc?.locations,
        ...!Array.isArray(checkDoc?.fields) ? [] : checkDoc?.fields,
        ...!Array.isArray(checkDoc?.dates) ? [] : checkDoc?.dates 
    ]
    //all fields of the device template, and then find the ones where unique is true
    const dates = !Array.isArray(currentTemplate?.dates) ? [] : currentTemplate?.dates
    const allFieldsInTemplate = [
        ...!Array.isArray(currentTemplate?.locations) ? [] : currentTemplate?.locations,
        ...!Array.isArray(currentTemplate?.fields) ? [] : currentTemplate?.fields, 
        ...dates 
    ]
    const uniqueFieldsInTemplate = !allFieldsInTemplate ? [] : allFieldsInTemplate.filter?.(x=>x.unique)
    // all the devices in the register and all their fields
    const registerDevices = !devices ? [] : devices?.filter?.(device=>(device?.register?._ref=== register?._id && device.status !== "ARCHIVIATO"))
    //console.log("jkjscndsjc", devices, register)

    const deviceFieldsArray = (device) => {
        const fields = !device?.fields ? [] : device?.fields
        const locations = !device?.locations ? [] : device?.locations
        const dates = !device?.dates ? [] : device?.dates
        return ([
            ...!Array.isArray(locations) ? [] : locations,
            ...!Array.isArray(fields) ? [] : fields,
            ...!Array.isArray(dates) ? [] : dates ])
    }
    const allDeviceFields = !Array.isArray(registerDevices) ? [] : registerDevices.map?.((x)=>deviceFieldsArray(x))
   
    const allFieldsInDevicesExcludesCurrent = !Array.isArray(registerDevices) ? [] : registerDevices
    ?.filter?.(y=>{
        if(duplicateDevice) return y
        return y._id !== checkDoc._id})
    ?.map?.((x)=>deviceFieldsArray(x))
    const allFieldsInDevices = !Array.isArray(registerDevices) ? [] : registerDevices.map?.((x)=>deviceFieldsArray(x))


    function sortByValue( a, b ) {
        const isNumber = !!Number(a?.value) && !!Number(b?.value)
        if (isNumber) return  a.value - b.value
        if ( a?.value < b?.value ){
          return -1;
        }
        if ( a?.value > b?.value ){
          return 1;
        }
        return 0;
      }


/**
 * Extracts field values from device fields array matching a template field
 * Searches through device field arrays and returns matching field values with IDs
 * #deviceFields
 * @param {Object} item Template field object with _id property to match against
 * @param {Array} array Array of device field arrays to search through
 * @returns {Array<{fieldId: string, value: string}>} Array of objects containing fieldId and value pairs, sorted by value
 */
const deviceFieldValues = (item, array) => {
    if (!array || !item || !Array.isArray(array)) return [];
    return array
        .map?.(x => (x || []).filter?.(y => y?.templateField?._ref === item?._id))
        .flat(2)
        .map?.(item => item?.values?.map(value => ({
            fieldId: item?.templateField?._ref,
            value: value?.value
        })))
        .flat(2) 
        .filter?.(x => x?.value != undefined)
        .sort(sortByValue);
}
    
/**
 * Validates field values for uniqueness and required field constraints
 * Checks if a field value already exists in other devices or if required fields are missing
 * #deviceFields
 * 
 * @param {Object} item Template field object containing validation rules and _id
 * @param {boolean} [isRequired=false] Whether to check for required field validation instead of uniqueness
 * @returns {boolean} True if validation error found (duplicate value or missing required field), false if valid
 */
const errorCheck = (item, isRequired) =>{
    // finds the first value in the array to check inside the doc
    const valueToCheck = (item) => !Array.isArray(allFieldsInDoc) ? undefined : allFieldsInDoc?.find?.((x)=>x?.templateField?._ref == item?._id)?.values?.[0]?.label
    /*  console.log("valueToCheck kqdkqopwdk", {
        valueToCheck: valueToCheck(item),
        deviceFieldsValuesIfNotRequired: deviceFieldValues(item, allFieldsInDevicesExcludesCurrent)?.some?.((z)=>z?.value == valueToCheck(item)),
        allFieldsInDevicesExcludesCurrent,
        allFieldsInDoc,
        isRequired,
    }) */
    if(isRequired) {
        return !valueToCheck(item) ? true : false
    }
    return deviceFieldValues(item, allFieldsInDevicesExcludesCurrent)?.some?.((z)=>z?.value == valueToCheck(item))

}
    
/**
 * Generates comprehensive position information for device location management
 * Analyzes existing device positions to determine available slots and missing positions
 * #deviceFields
 * @returns {Object} Position analysis object containing:
 * - positionsExcludesCurrent: Array of positions excluding current device
 * - highest: Highest position number found
 * - allpositions: All position numbers in use
 * - missingPositions: Array of available position numbers between existing ones
 * - message: Localized message describing position availability
 * - label: Field label for position field
 */
const positionsString = () => {
    const positionFieldTemplate = !Array.isArray(uniqueFieldsInTemplate) ? undefined : uniqueFieldsInTemplate?.find?.((x)=>x?.label == "N. POST")
    const allDeviceFieldsArray = deviceFieldValues(positionFieldTemplate, allDeviceFields)
    const allDeviceFieldsArrayNoCurrent = deviceFieldValues(positionFieldTemplate, allFieldsInDevicesExcludesCurrent)

        const allpositions = !Array.isArray(allDeviceFieldsArray) ? [] : allDeviceFieldsArray?.map?.((x)=>Number(x?.value))
        const positionsExcludesCurrent = !Array.isArray(allDeviceFieldsArrayNoCurrent) ? [] : allDeviceFieldsArrayNoCurrent?.map?.((x)=>Number(x?.value))
        const highest = Array.isArray(allpositions) && allpositions.length > 0 ? 
            allpositions.reduce((p,c) => Math.max(p, c), 0) : 0
        let missingPositions = []
        //adds to missingPositions
        Array.isArray(allpositions) && allpositions?.filter?.(y=>y)?.reduce((p,c)=>{
            if( c - p > 1){
                const nMissing = (c - p)
                let i = 1
                while(i<nMissing) {
                    missingPositions.push(p + i)
                    i++
            }
                return c 
        }
            return c
        },0)



    const message = () => {
        const allPositionsAvailable = () => {
                if(language == "en") return  `ALL POSITIONS AVAILABLE`
                return `TUTTE LE POSTAZIONI SONO DISPONIBILI`
        }
        const noMissingPositions = () => {
                if(language == "en") return `THE LAST POSITION IS ${highest}. THERE ARE NO POSITIONS MISSING`
                return`L'ULTIMA POSTAZIONE PRESENTE E' ${highest}. NON CI SONO POSTAZIONI MANCANTI`

        }
        const missingPositionsMessage = () => {
                if(language == "en") return `THE LAST POSITION IS ${highest}. POSITIONS ${missingPositions?.toString()} ARE AVAILABLE`
                return`L'ULTIMA POSTAZIONE PRESENTE E' ${highest} E LE POSTAZIONI ${missingPositions?.toString()} SONO DISPONIBILI`


        }
            if(allpositions.length<1) return allPositionsAvailable()
            if(highest && missingPositions?.length<1 ) return  noMissingPositions()    
            return  missingPositionsMessage()
    }
        const obj = {positionsExcludesCurrent, highest, allpositions, missingPositions, message: message(), label:"N. POST" }
        return obj

    }



    //  #deviceFields an array of all the fields that need to be unique, returns
    const isUnique = !Array.isArray(uniqueFieldsInTemplate) ? [] : uniqueFieldsInTemplate.map?.((item)=>{
        const positionsExcludesCurrentArray = deviceFieldValues(item, allFieldsInDevicesExcludesCurrent)
        const positionsExcludesCurrent = !Array.isArray(positionsExcludesCurrentArray) ? [] : positionsExcludesCurrentArray?.map?.((x)=>Number(x?.value))
        //const positions = deviceFieldValues(item, allFieldsInDevices).map?.((x)=>Number(x?.value))
        
        const highest = positionsExcludesCurrent?.length > 0 && positionsExcludesCurrent?.reduce((p,c)=>{
            if(p > c) return p
            return c
        },0)
        let missingPositions = []
        //adds to missingPositions
        Array.isArray(positionsExcludesCurrent) && positionsExcludesCurrent?.filter?.(y=>y)?.reduce((p,c)=>{
            if( c - p > 1){
                const nMissing = (c - p)
                let i = 1
                while(i<nMissing) {
                    missingPositions.push(p + i)
                    i++
                }
                return c 
            }
            return c
        },0)

        const check = errorCheck(item)
        const errorNotUnique = () => {
            if(language == "en") return `THE FIELD ABOVE IS NOT UNIQUE`
            return  `${item?.label} NON E' UNIVOCO`
        }
        const errorNotUniqueWithPosition = () => {
            if(language == "en") return `THE FIELD ABOVE IS NOT UNIQUE, THE LAST POSITION IS ${highest}`
            return `${item?.label} NON E' UNIVOCO, L'ULTIMA POSTAZIONE PRESENTE E' ${highest}`
        }
        const errorNotUniqueWithMissingPosition = () => {
            if(language == "en") return  ` AND POSITIONS ${missingPositions?.toString()} ARE AVAILABLE`
            return ` E LE POSTAZIONI ${missingPositions?.toString()} SONO DISPONIBILI`
        }
        const errorMessage = item?.label == "N. POST" ? errorNotUniqueWithPosition() : errorNotUnique()
        const errorMissing = () => { 
            
            if(missingPositions?.length>0) return errorNotUniqueWithMissingPosition()
            return ""
        }
        return {check, fieldName: item.label, templateId: item._id, errorMessage: errorMessage + errorMissing()}
    })
     //-------------------------------------------------------------------- CORRECT FIELD VALUES IN LIST (BACAME INNER LIST IN RegisterTemplateData)-----------------------------------------------------------------------

     
     //const dropdownFieldsInTemplate = allFieldsInTemplate.filter?.(x=>x?.fieldType == "dropdown")
             
/*      const substituteFieldsToCheck = !Array.isArray(substituteDeviceFields) ? [] : substituteDeviceFields.map?.(x=>allFieldsInTemplate?.find((y)=>y?._id == x?.templateField?._ref ))

     const areAllFieldsInList = !Array.isArray(dropdownFieldsInTemplate) ? [] : dropdownFieldsInTemplate.map?.((item)=>{
        const availableOptions = listOptions(item, currentTemplateDevice) 
        const thisDeviceFieldsArray = deviceFieldValues(item, [allFieldsInDoc]) 
        const areLabelsAllInAvailableOptions = !Array.isArray(thisDeviceFieldsArray) ? [] : thisDeviceFieldsArray?.map?.((x)=>availableOptions?.some?.((z)=>z?.label == x?.value))
        const check = !Array.isArray(areLabelsAllInAvailableOptions) ? true : areLabelsAllInAvailableOptions?.every(x=>x == true)
         return {check: !check, item, substituteDeviceFields, substituteDevice, currentTemplateDevice, availableOptions, areLabelsAllInAvailableOptions, thisDeviceFieldsArray, fieldName: item?.label, templateId: item?._id, errorMessage:`${item?.label} HA UN CAMPO CHE NON E' NELLA LISTA.`}
     }) */

/*     const areAllSubFieldsInList = !Array.isArray(substituteFieldsToCheck) ? [] : substituteFieldsToCheck.map?.((item)=>{
        const availableOptions = listOptions(item, substituteDevice) 
        const thisDeviceFieldsArray = deviceFieldValues(item, [ [...!Array.isArray(substituteDeviceFields) ? [] : substituteDeviceFields]])
        const areLabelsAllInAvailableOptions = !Array.isArray(thisDeviceFieldsArray) ? [] : thisDeviceFieldsArray?.map?.((x)=>availableOptions?.some?.((z)=>z?.label == x?.value))
        const check = !Array.isArray(areLabelsAllInAvailableOptions) ? true : areLabelsAllInAvailableOptions?.every(x=>x == true)
         return {check: !check, item, substituteDeviceFields, substituteDevice, currentTemplateDevice, availableOptions,  areLabelsAllInAvailableOptions, thisDeviceFieldsArray, fieldName: item?.label, templateId: item?._id, errorMessage:`${item?.label} HA UN CAMPO CHE NON E' NELLA LISTA.`}
     }) */
     //console.log("jddjalkjsdklasdjalksjd", {areAllFieldsInList } )

  //-------------------------------------------------------------------- REQUIRED FIELDS -----------------------------------------------------------------------
  //  #deviceFields

     const requiredFieldsInTemplate =  allFieldsInTemplate.filter?.(x=>x?.required)
     const isRequired = !Array.isArray(requiredFieldsInTemplate) ? [] : requiredFieldsInTemplate.map?.((item)=>{
        const positionsExcludesCurrentArray = deviceFieldValues(item, allFieldsInDevicesExcludesCurrent)
        const positionsExcludesCurrent = !Array.isArray(positionsExcludesCurrentArray) ? [] : positionsExcludesCurrentArray?.map?.((x)=>Number(x?.value))
        const allPositionsArray = deviceFieldValues(item, allFieldsInDevices)
        const allPositions = !Array.isArray(allPositionsArray) ? [] : allPositionsArray?.map?.((x)=>Number(x.value))

        const highest = Array.isArray(positionsExcludesCurrent) && positionsExcludesCurrent.length > 0 ? 
            positionsExcludesCurrent.reduce((p,c) => Math.max(p, c), 0) : 0
        let missingPositions = []
        //adds to missingPositions
        Array.isArray(allPositions) && allPositions?.filter?.(y=>y)?.reduce((p,c)=>{
                if( c - p > 1){
                    const nMissing = (c - p)
                    let i = 1
                    while(i<nMissing) {
                        missingPositions?.push(p + i)
                        i++
                    }
                    return c 
                }
                return c
            }, positionsExcludesCurrent?.filter?.(y=>y)[0])
            const errorMessage = item?.label == "N. POST" && `L'ULTIMA POSIZIONE PRESENTE E' ${highest} E LE POSIZIONI ${missingPositions?.toString()} SONO DISPONIBILI`
    
        const check = errorCheck(item, true)
        return {check, item, fieldName: item?.label, templateId: item?._id, errorMessage:`${item?.label} E' OBBLIGATORIO. `+ missingPositions?.length>0 && errorMessage}

     })
    const errorCallback = (data) => {
        console.log("dmqlkdmqwkdm error callback", data)
        setInnerErrorFound(data)
    }
    const allErrors = [
        //...!Array.isArray(areAllFieldsInList) ? [] : areAllFieldsInList,
        ...!Array.isArray(isUnique) ? [] : isUnique, 
        ...!Array.isArray(isRequired) ? [] : isRequired
    ]
    const errorFound = allErrors.some?.((x)=>x?.check) || innerErrorFound?.check 
    const saveButtonColour = errorFound ? "grey" : "green"

// ============================================ SAVE DEVICE E MUTATIONS =============================================


/**
 * Assigns a QR code URL to the current device after validation
 * Validates QR code URL format and checks for duplicates across all registers
 * #qrCode
 * @param {Array} data Array containing scanned QR code data with rawValue property
 */
const assignQr = (data) => {
   
    const scannedQrUrl = data?.[0]?.rawValue
    console.log("Assign qr lakwejfhliwueFH", {data, scannedQrUrl})

    if(scannedQrUrl && !scannedQrUrl?.includes("http://localhost:8080/qr/") && !scannedQrUrl?.includes("https://apis.relyonfm.com/qr/") && !scannedQrUrl?.includes("https://apis.gssmega.app/qr/")) {
        errorAlert("QR CODE URL NON VALIDO")
        return 
    }
    const newDoc = {...objectIsObject(device), qrUrl: scannedQrUrl}
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, newDoc),
        doc: addLogToDoc(sUser, newDoc, "creato qr code"),
    }
    if(!scannedQrUrl) { 
        errorAlert("QR CODE URL NON TROVATA")
        return 
    }
    if (networkStatus) {
        _FETCH({
            route: fetchRoute,
            //route: scannedQrUrl,
            user: user,
            query: `*[_type == "register" && "${scannedQrUrl}" in devices[].qrUrl]{
                ...,
                site->{
                    ...,
                    client->{
                        ...,
                        customer->,
                        
                        }
                    },
            }`,
            
            onSuccess: (data) => {
                if(data?.length > 0){
                    errorAlert("QUESTO CODICE E' GIA' STATO ASSEGNATO")
                return
                }
                replaceDevice(queryDoc)
        
            },
            onError: (error) => {
                console.log("RECEIVING ERROR FROM QR FETCH", {error, scannedQrUrl})
                errorAlert("NON E' STATO POSSIBILE COLLEGARSI AL SERVER PER PER CONTROLLARE CHE IL CODICE SIA GIA' IN UTILIZZO")
            }
        
        })
    }
    if(!networkStatus) {
        offlineFn(queryDoc, registers)
    }

} 
/**
 * Removes QR code assignment from current device with confirmation dialog
 * Shows confirmation dialog before removing QR code URL from device
 * #qrCode
 */
const unassignQr = () => {

    Swal.fire({
        title: "Vuoi Rimuovere Il Qr Code",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Sì",
        cancelButtonText: "No"
      }).then((result) => {
        if (result.isConfirmed) {
            console.log("Unsssign qr kawjenf")
            const newDoc = {...objectIsObject(device), qrUrl: undefined}
            const queryDoc = {
                id: register?._id, 
                key: findKey(register, newDoc),
                doc: addLogToDoc(sUser, newDoc,"eliminato qr code"),
            }
            if(!networkStatus) {
                //console.log("OFFLINE")
                offlineFn(queryDoc, registers)
            }
            else{
             replaceDevice(queryDoc)}
        }
      })

}
/**
 * #deviceNonConformities
 * Adds an array of non-conformities to the current device
 * If the input data is undefined, an empty array is used
 * Updates the device with the new non-conformities array
 * If offline, the function will call offlineFn to store the data locally
 * If online, the function will call replaceDevice to update the device on the server
 * @param {Array} data - array of non-conformities to add to the device
 */
const addNonConformities = (data) => {
    const array = data ? data : []
    const nonConfUpdateDoc = {...objectIsObject(device), nonConformities:[...!Array.isArray(array) ? [] : array]}
    const customFn = () => {
        setDeviceIndexPage("DEVICE")
    }
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, nonConfUpdateDoc),
        doc: addLogToDoc(sUser,nonConfUpdateDoc,"created"),
        customFn
    }
         if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers) 
    }
    else{
     replaceDevice(queryDoc)}
}

/**
 * #deviceFields
 * Determines device field updates based on non-conformity template configuration
 * Analyzes non-conformity to identify associated device fields and maintenance dates
 * Prepares field values and date objects for device updates
 * 
 * @param {Object} nonConformity Non-conformity object containing reference to template
 * @returns {Object} Object containing deviceField, fieldTemplate, maintenanceFieldTemplate, maintenanceDeviceField, and datesValue
 */
const updateDeviceField = (nonConformity) => {

    const allTemplateNonConformities = (x) =>{ 
        const nonConformities = !x?.nonConformities ? [] : x?.nonConformities
        const array = [
            ...!Array.isArray(nonConformities) ? [] : nonConformities, 
            x?.maxNonConformity, 
            x?.minNonConformity, 
            x?.zeroNonConformity ]
                ?.filter?.(x=>x)
        //console.log("array", array, x)
        return array
    }
    const fieldTemplate = !Array.isArray(currentTemplate?.fields) ? undefined : currentTemplate?.fields?.find?.(x=>allTemplateNonConformities(x)?.find?.(y=>y?._id == nonConformity?.nonConformity?._ref))
    const deviceField = !Array.isArray(device?.fields) ? undefined : device?.fields?.find?.(x=>x?.templateField?._ref==fieldTemplate?._id)

    const maintenanceFieldTemplate = !Array.isArray(currentTemplate?.dates) ? undefined : currentTemplate?.dates?.find?.(x=>allTemplateNonConformities(x)?.find?.(y=>y?._id == nonConformity?.nonConformity?._ref))
    const maintenanceDeviceField = !Array.isArray(device?.dates) ? {} : device?.dates?.find?.(x=>x?.templateField?._ref==maintenanceFieldTemplate?._id)
    
    const currentYear = new Date().getFullYear()
    const findListAnni = !Array.isArray(maintenanceFieldTemplate?.lists) ? undefined : maintenanceFieldTemplate?.lists?.find?.(x=>x?.listName=="ANNI")
    const findCurrentYear = !Array.isArray(findListAnni?.fieldList) ? undefined : findListAnni?.fieldList?.find?.(x=>x?.label==currentYear)
    const datesValue = {...objectIsObject(maintenanceDeviceField), values:[findCurrentYear]?.filter?.(x=>x)}  

    return ({deviceField, fieldTemplate, maintenanceFieldTemplate, maintenanceDeviceField, datesValue})
}

/**
 * Deletes a non-conformity from the current device
 * #deviceNonConformities
 * @param {Object} data Non-conformity object to delete
 */
const deleteNonConformity = (data) => {
    const deviceNonConformities = device?.nonConformities ? device?.nonConformities : []
    const updatedDevice = {...objectIsObject(device), nonConformities: !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities?.filter?.((x)=>x?._id !== data?._id)}
    console.log("DELETE NON CONFORMITY", data, device, updatedDevice)
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, updatedDevice),
        doc: addLogToDoc(sUser,updatedDevice,"deletedNonConformity"),
    }
         if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)}
}

/**
 * #deviceNonConformities
 * Updates device non-conformity status and associated field values
 * Handles completion/archival of non-conformities and updates related device fields
 * Manages different field types (boolean, minMax, maintenance dates) appropriately
 * 
 * @param {Object} data Non-conformity object with status and reference information
 * @param {Array} updatedField Array containing updated field values for minMax fields
 */
const updateNonConformity = (data, updatedField) => {
    
    const deviceFieldValue = [updateDeviceField(data)?.deviceField ? updateDeviceField(data)?.deviceField : updateDeviceField(data)?.maintenanceDeviceField]
    
    const nonConformities = device?.nonConformities ? device?.nonConformities : []
    const findNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.(x=>x?._id == data?._id)
    const filteredNonConformities = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.(z=>z?._id !== findNonConformity?._id )
    const updatedNonConformityDoc = () => {

        if(data?.status == "COMPLETATO" || data?.status == "ARCHIVIATO") {
            if(updateDeviceField(data)?.fieldTemplate?.fieldType=="boolean"){ 
           
                const newfields = device.fields.filter?.(x=>x?.templateField?._ref !== deviceFieldValue[0]?.templateField?._ref)
                const newDevice = {...objectIsObject(device), fields:newfields, nonConformities:[...!Array.isArray(filteredNonConformities) ? [] : filteredNonConformities, data]}
                return newDevice      
            }
            else if(updateDeviceField(data)?.fieldTemplate?.fieldType=="minMax"){
           
                const newfields = device.fields.filter?.(x=>x?.templateField?._ref !== deviceFieldValue[0]?.templateField?._ref)
                const newDevice = {...objectIsObject(device), fields:[...!Array.isArray(newfields) ? [] : newfields, updatedField?.[0]], nonConformities:[...!Array.isArray(filteredNonConformities) ? [] : filteredNonConformities, data]}
                return newDevice 
            }
            else if(updateDeviceField(data)?.maintenanceFieldTemplate){
               
                const newfields = device.fields.filter?.(x=>x?.templateField?._ref !== deviceFieldValue[0]?.templateField?._ref)
                const newDevice = {...objectIsObject(device), dates:[...!Array.isArray(newfields) ? [] : newfields, updateDeviceField(data)?.datesValue],nonConformities:[...!Array.isArray(filteredNonConformities) ? [] : filteredNonConformities, data]}
                return newDevice 
            }
            else {
                
                return({...objectIsObject(device), nonConformities:[...!Array.isArray(filteredNonConformities) ? [] : filteredNonConformities, data]})}
        }
       
        return({...objectIsObject(device), nonConformities:[...!Array.isArray(filteredNonConformities) ? [] : filteredNonConformities, data]})
    }  
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, updatedNonConformityDoc()),
        doc: addLogToDoc(sUser,updatedNonConformityDoc(),"NonConformityUpdated"),
    }
        if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)}
}

/**
 * Edits a comment in the device object and updates the register in offline or online mode
 * #comments
 * @param {Object} data Comment object to be edited
 */
const editComment = (data) => {
    //console.log(data)
    const comments = device?.comments ? device?.comments.filter?.(x=>x?._id !== data?._id) : []
    const newCommentDoc = {...objectIsObject(device), comments:[...!Array.isArray(comments) ? [] : comments, data]}
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, newCommentDoc),
        doc: addLogToDoc(sUser,newCommentDoc,"commentUpdated"),
    }
         if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)}
    
}

/**
 * Inserts a picture in the device object and updates the register in offline or online mode
 * #pictures
 * @param {Object} data Picture object to be inserted
 */
const insertPicture = (data) => {
    //console.log(data)
    const pictures = device?.images ? device?.images : []
    const newPictureDoc = {...objectIsObject(device), images:[...!Array.isArray(pictures) ? [] : pictures, data]}
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, newPictureDoc),
        doc: addLogToDoc(sUser,newPictureDoc,"imageAdded"),
    }
         if(!networkStatus) {
        //console.log("OFFLINE PICTURE", queryDoc)
        offlineFn(queryDoc, registers)
        setLoading(false)  
    }
    else{
     replaceDevice(queryDoc)}
}
/**
 * Inserts a picture in the device object and updates the register in offline or online mode
 * #pictures
 * @param {Object} data Picture object to be inserted
 */
const insertPictureSanity = (data) => {
    //console.log(data)
    const pictures = device?.image ? device?.image : []
    const newPictureDoc = {
        ...objectIsObject(device), 
        image:[...!Array.isArray(pictures) ? [] : pictures, data]
    }
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, newPictureDoc),
        doc: addLogToDoc(sUser,newPictureDoc,"imageAdded"),
    }
         if(!networkStatus) {
        //console.log("OFFLINE PICTURE", queryDoc)
        offlineFn(queryDoc, registers)
        setLoading(false)  
    }
    else{
     replaceDevice(queryDoc)}
}
//==================== #devices ====================
const restoreDevice = (bypassNavigation = false, customFnRestore = ()=>{}) => {
    const restoreDoc = {...objectIsObject(device), status:"ATTIVO"}
    const customFn = () =>{
        !bypassNavigation && setIndexPage("HOME")
        customFnRestore()
    }
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, restoreDoc),
        doc: addLogToDoc(sUser,restoreDoc,"restored"),
        customFn
    }
    if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)
    }
}

const archiveDevice = (bypassNavigation = false, customFnArchive = ()=>{}, subbedWithId=undefined) => {

    const archiveDoc = {
        ...objectIsObject(device), 
        status:"ARCHIVIATO",
        subbedWithId: subbedWithId
    }
    const customFn = () =>{
        !bypassNavigation && setIndexPage("HOME")
        customFnArchive()
    }
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, archiveDoc),
        doc: addLogToDoc(sUser,archiveDoc,"archived"),
        customFn
    }
    if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)
    }

}

/**
 * Creates multiple duplicate devices with auto-incremented position numbers
 * Generates specified number of device duplicates with unique positions and IDs
 * Handles offline/online scenarios and updates register with batch device creation
 * #duplicateDevice
 * #doneCheck
 * 
 * @async
 */
const duplicateNTimes = async () => {
        let allPositions = positionsString()?.allpositions?.sort(sortByArrayElement)
        
        const getNextPosition = () => {
            const findCurrentPositionDoc = !Array.isArray(device?.locations) ? {} : device?.locations?.find?.(x=>x?.templateField._ref == "5710d994-8bc9-4981-a5af-94a535d27bbd")
            const oldPosition = findCurrentPositionDoc?.values?.length > 0 && findCurrentPositionDoc?.values?.[0]?.value
            
            const newPosition = allPositions.reduce((nextPos, position) => {
                if (nextPos) return nextPos
                const candidatePosition = position + 1
                const isNextPositionPresent = allPositions?.some?.((x)=>x == candidatePosition)
                if (candidatePosition > +oldPosition && !isNextPositionPresent) {
                    return candidatePosition
                }
                return undefined
            }, undefined)

            const positionDoc = {
                ...objectIsObject(findCurrentPositionDoc),
                values:[{
                    value: newPosition?.toString(),
                    label: newPosition?.toString(),
                    _key: keyId(),
                    _type: "deviceProperty"
                }]
            }
            allPositions?.push(newPosition)
            return positionDoc
        }

        const newDuplicateDevices = Array.from({length: nTimes}, () => {
            const newDuplicateDoc = {
                ...objectIsObject(newDoc), 
                _id: uuidv4(), 
                register: referenceDoc(register?._id),
                site: referenceDoc(site?._id),
                _key: keyId(), 
                locations: [
                    ...!Array.isArray(device?.locations) ? [] : device?.locations.filter?.(x=>x?.templateField._ref !== "5710d994-8bc9-4981-a5af-94a535d27bbd"), 
                    getNextPosition()
                ]
            }
            
            return {
                id: register?._id,
                doc: sUser?.userType == "Tecnico" ? 
                    addLogToDoc(sUser, newDuplicateDoc, "check") : 
                    addLogToDoc(sUser, newDuplicateDoc, "created"),
                key: findKey(register, newDuplicateDoc),
                newDoc: true
            }

        })
        console.log("wsjoqisjoiqwjs duplicate nTimes", {newDuplicateDevices})
        const existingDevices = (register?.devices?.length > 0 && register?.devices) ? register?.devices : []
            const newRegister = {
                ...objectIsObject(register), 
                devices:[
                    ...!Array.isArray(existingDevices) ? [] : existingDevices, 
                    ...!Array.isArray(newDuplicateDevices) ? [] : newDuplicateDevices?.map((x)=>x?.doc)]
                }
        if(!networkStatus) {
                const newRegisters = [...!Array.isArray(registers) ? [] : registers?.filter?.(x=> x?._id !== newRegister?._id), newRegister]
                setFailedDevicesQueryDocs([
                    ...!Array.isArray(failedDevicesQueryDocs) ? [] : failedDevicesQueryDocs,
                    ...!Array.isArray(newDuplicateDevices) ? [] : newDuplicateDevices?.map((x)=>x?.doc)
                ])
                setRegisters(newRegisters)
                setRegister(newRegister)
                setDuplicateDevice(false);
                setDeviceEdit(false);
                setIndexPage("HOME");

            }
        else {
            //console.log(`OLD REGISTER`, register, "NEW REGISTER", newRegister)

            const queryDoc = {
                doc: newRegister,
            }
            //console.log("Adding Document diuhjqodhi:", queryDoc)
            updateRegister(queryDoc)
        }


        }

/**
 * Main save device function with comprehensive error handling and offline support
 * Handles both new device creation and updates to existing devices
 * Validates for errors before saving, manages state updates, and handles network/offline scenarios
 * #devices
 * @throws {Error} When device key already exists or other validation errors occur
 */
const saveDevice = () => {
    const start = Date.now();
    if(errorFound) {
        return;
    }
    try {
        if(!device?._id || duplicateDevice) {
            const queryDoc = {
                id: register?._id,
                key: findKey(register, newDoc),
                doc: sUser?.userType == "Tecnico" 
                    ? addLogToDoc(sUser, newDoc, "check") 
                    : addLogToDoc(sUser, newDoc, "created"),
                newDoc: true
            };

            if(!networkStatus) {
                offlineFn(queryDoc, registers);
            } else {
                const keyExists = register?.devices?.some?.((x) => x?._key == newDoc?._key);
                if(keyExists) {
                    throw new Error("questo presidio esiste già");
                    return
                }
                replaceDevice(queryDoc);
            }
            
            // Keep state updates immediate for both paths
            setDeviceEdit(false);
            setDuplicateDevice(false);
            setSubTrackedChanges([]);
            setTrackedChanges([]);
            const docForLog = queryDoc?.doc
            const deviceLogs = docForLog?.userLog ? docForLog?.userLog : []
            const expandLogs = !Array.isArray(deviceLogs) ? [] : deviceLogs?.map?.((x)=>{
                const findUser = !Array.isArray(customerUsers) ? undefined : customerUsers?.find?.(x=> sUser?._id == x._id)
                console.log("Checking done by findUser", {customerUsers, findUser})
                return {...objectIsObject(x), log:{postedBy: findUser}}
            }) 
            console.log("Checking done by", {expandLogs, log: expandLogs?.[0], docForLog})
            setDoneBy(expandLogs?.[0])
            setIndexPage("DEVICE");
            
        } else {
            const queryDoc = {
                id: register?._id,
                key: findKey(register, updateDoc),
                doc: addLogToDoc(sUser, updateDoc, "updated", historyDoc)
            };

            if(!networkStatus) {
                offlineFn(queryDoc, registers);
            } else {
                replaceDevice(queryDoc);
            }
            
            // Keep state updates immediate for both paths
            setDeviceEdit(false);
            setSubTrackedChanges([]);
            setTrackedChanges([]);
            setIndexPage("DEVICE");
        }
    } catch (err) {

        console.error('Save failed oiejqweoije:', err);            
        const queryDoc = {
            id: register?._id,
            key: findKey(register, updateDoc),
            doc: addLogToDoc(sUser, updateDoc, "updated", historyDoc)
        };
        const errorToEmail = {
            internalErrorId: "oiejqweoije",
            functionName: "saveDevice",
            page: "device.js",
            subject: "Error saving device ",
            err: err,
            message: err?.message,
            registersCount: registers?.length,
            timeTaken: Date.now() - start,
            trackedChanges: trackedChanges,
            user: sUser?.lastName,
            subTrackedChanges: subTrackedChanges,
            networkStatus: networkStatus,
            queryDoc: queryDoc,  
        }

        errorAlert(`Non è stato possibile salvare in offline. Spedire l'errore e riprovare`, err?.internalErrorId ? err : errorToEmail);
    }
};


/**
 * Handles cancellation of device editing with user confirmation
 * Shows confirmation dialog warning about data loss before discarding changes
 * Resets device editing state and navigation if confirmed
 */
const cancel = () => {
    const alert = () => {
        Swal.fire({
            title:  LDB(P, "cancelQ"),
            text: LDB(P, "dataLost"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: LDB(P, "yesCancel"),
            cancelButtonText: LDB(P, "keepEditing")
          }).then((result) => {
            if (result.isConfirmed) {
              setDuplicateDevice(false)
              setDeviceEdit(false); 
              scroll(0,0)
              !device && setIndexPage("HOME")

            }
          })
    }
  
    alert()
}
/**
 * Supply the device by setting its status to "ATTIVO" and setting the current date as its production date.
 * If the device is offline, it will add the update to the offline queue.
 * If the device is online, it will update the device in the database.
 * After the update, it will reset the page to the home page.
 * #supplyDevice
 */
const supplyDeviceFn = () => {
    const dates = device?.dates
    const isProductionDatePresent = dates?.some?.(y=>y?.templateField?._ref ==  templateProductionField?._id)
    const dateArray = isProductionDatePresent ? dates : [currentDateinField(templateProductionField)]
    const supplyDoc = {...objectIsObject(device), status:"ATTIVO", dates: dateArray }
    const customFn = () =>{
        setIndexPage("HOME")
    }
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, supplyDoc),
        doc: addLogToDoc(sUser,supplyDoc,"supplied"),
    }
         if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)}
     

}
useEffect(()=> {
    if(isSubstituting) {
        console.log("is substituting", device?._id)
        setDeviceEdit(true)
        setIsSubstituting(false)
    }
},[device?._id])

/**
 * Handles complete device substitution workflow
 * Archives current device, creates new substitute device with proper configuration
 * Manages navigation state, user logs, and duplicate key validation
 * Coordinates between archival and creation operations
 * #substituteDevice
 */
const substituteDeviceFn = () => {
    const doc = sUser?.userType == "Tecnico" ? addLogToDoc(sUser,substituteDoc,"check") : addLogToDoc(sUser,substituteDoc,"created")
    const navigate = () => {
        setIndexPage("DEVICE")
        window.scrollTo(0, 0);
        console.log("END SUB", doc?._id)
        setIsSubstituting(true)
        
        //setCurrentDevice(doc)
        //setDeviceEdit(true)
    }
    const queryDoc = {
        id:register?._id,
        doc,
        key: findKey(register, doc),
        customfn: navigate(),
        newDoc: true,
    }
    const afterArchive = () => {
        //setCurrentDevice(queryDoc?.doc)
        const keyExists = register?.devices?.some?.((x) => x?._key == doc?._key);
        if(keyExists) {
            throw new Error("questo presidio esiste già");
            return
        }
        
        //addToArray(queryDoc)
        replaceDevice(queryDoc)
        //setDeviceEdit(false); 
        //setIndexPage("DEVICE")
        //setDeviceEdit(true)
    }

    //console.log("SUB BUTTON", substituteDoc)
    archiveDevice(true, afterArchive, doc?._id)



}

/**
 * Checks if the substitute button should be visible
 * #substituteDevice
 * @returns {boolean} true if the substitute button should be visible, false otherwise
 * 
 * Checks if the user is a facility client, if the user is a client user, if the device is not being edited, 
 * if the device status is "DA SOSTITUIRE", if the substitute reason is "SCADUTO", if the device has an expiry deadline
 * and if the device should be substituted based on the deadline type and client revision
 */
const isSubButtonVisible = () => {
    //facilityClient(client, sUser), clientUser(sUser),!deviceEdit, device?.status == "DA SOSTITUIRE" || substituteReason?.label == "SCADUTO"
    if (!facilityClient(client, sUser)) return false
    if(!clientUser(sUser)) return false
    if(substituteReason?.label == "SCADUTO" && !deviceDeadlines?.checkData?.expiry?.date) return false
    if(device?.status == "DA SOSTITUIRE") return true
    if(deviceStatus == "DA SOSTITUIRE") return true
    if(statusTranslation)
    if(substituteReason?.label == "SCADUTO") return true
    if(activateSubstitutionFromDeadlineType()) return true
    //if(deviceEdit) return false
    return false
}



// ============================================ ON DONE CHECK #doneCheck ===============================================



/**
 * Handles completion of device check/verification with geolocation tracking
 * Updates device status, logs check action with timestamp and location data
 * Manages QR code validation and offline/online synchronization
 * #doneCheck
 * @param {Object} [data={}] Optional configuration object
 * @param {boolean} data.bypassQrPresent Skip QR code presence check
 * @param {boolean} data.scannedWithQr Whether check was performed via QR scan
 */
const onDoneClick = async(data={}) => {

        const {bypassQrPresent, scannedWithQr} = data

        const doneFn = async(position) => { 
            if(checkStatus == "FATTO") {
                
                return
            }    
            if (checkStatus == "DA FARE"){
                setCheckStatus("FATTO")

                const  newDoc = addLogToDoc(sUser, device, "check", undefined, position, scannedWithQr)

                const queryDoc = {
                    id: register?._id, 
                    key: findKey(register, device),
                    doc: newDoc,
                }
                
                const findUser = !Array.isArray(customerUsers) ? undefined : customerUsers?.find?.(x=>x._id==logDoc(sUser,"check",undefined, position, scannedWithQr)?.postedBy?._ref)
                const doneByDoc = { 
                    ...objectIsObject(logDoc(sUser,"check",undefined, position, scannedWithQr)),
                    postedBy: findUser }
                const newLog = userLogCheck(
                    {...objectIsObject(newDoc), 
                        userLog:[
                            ...!Array.isArray(deviceLogs) ? [] : deviceLogsExpanded(deviceLogs, customerUsers), 
                            doneByDoc
                        ]
                    }
                )    
                console.log("DONE BY", doneByDoc) 
                console.log("DONE BY LOG CHECK", newLog) 
                setDoneBy(newLog)

                if(!networkStatus) {
                    //console.log("OFFLINE")
                    offlineFn(queryDoc, registers)
                    setLoading(false) 
                    }
                else{
                    replaceDevice(queryDoc)
                }

            } else {
                //setCheckStatus(undefined)
                setLoading(false)
            }
        }
        const successCallback = (position) => {
            doneFn(position)

            };      
        const errorCallback = (error) => {
            doneFn()
            };
            
        const options = {
            enableHighAccuracy: true,
            timeout: 10000,
            };
                
        const geoPosition = () =>  {
            setLoading(true)
            return navigator.geolocation.getCurrentPosition(
                successCallback,
                errorCallback,
                options
            );}
        if(checkStatus == "FATTO") { 
             setLoading(false)  
            return
        } 
        if(device?.qrUrl && !bypassQrPresent) {
            Swal.fire({
                position: 'top',
                icon: 'warning',
                title: "NON E' POSSIBILE FARE UN CHECK SU UN PRESIDIO CON QR CODE MANUALMENTE. SCANNERIZZARE",
                showConfirmButton: false,
                timer: 3500
            })
            return
        }
        geoPosition()
    }

/**
 * Deletes the last log action from the device
 * Shows a confirmation dialog before deleting the log
 * If confirmed, updates the device document by removing the last log action
 * Manages offline/online synchronization
 * #doneCheck
 */
    const deleteLog = () => {
        Swal.fire({
            title:  "Eliminare il log?",
            //text: "Spedire l'errore o scaricare il file con i dati offline prima di eliminare. Chiama se non sei sicuro",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'red',
            cancelButtonColor: 'grey',
            confirmButtonText: "Sì, Elimina",
            cancelButtonText: "Annulla"
            }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true)
                const deviceWithoutLog = {...device, userLog: device.userLog.filter(x=>x._id != doneBy?.log?._id)}
                const queryDoc = {
                    id: register?._id, 
                    key: findKey(register, device),
                    doc: addLogToDoc(sUser, deviceWithoutLog, "log rimosso", undefined, false, false),
                }
                if(!networkStatus) {
                    //console.log("OFFLINE")
                    offlineFn(queryDoc, registers)
                    setLoading(false) 
                    }
                else{
                    replaceDevice(queryDoc)
                    //setLoading(true)
                }
                console.log("Deleting Log", {queryDoc, deviceWithoutLog, doneBy})
            }
        })
    }

    // #qrCode
    useEffect(() => {
        if(!qrCheck) return
        if(qrCheck) {

            console.log("oiujdoiqwjdioqw", "qr check", {qrCheck, checkStatus})
            if(!checkStatus) return
            if(checkStatus == "FATTO") {
                setQrCheck(false)
                return
            }
            if(checkStatus == "DA FARE"){
                Swal.fire({
                    title:  "Check Presidio?",
                    //text: "Spedire l'errore o scaricare il file con i dati offline prima di eliminare. Chiama se non sei sicuro",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: 'green',
                    cancelButtonColor: 'grey',
                    confirmButtonText: "Sì, Check",
                    cancelButtonText: "Annulla"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        onDoneClick({bypassQrPresent: true, scannedWithQr: true})
                    }
                    })
                 //onDoneClick({bypassQrPresent: true, scannedWithQr: true})
                 setQrCheck(false)
                 return
            }
            setQrCheck(false)
        }
    }, [qrCheck, checkStatus])

    const backButton = () => {
        setIndexPage("HOME")  
        setDuplicateDevice(false)
    }

    /**
     * Changes the substitute device and clears the substitute device fields array.
     * This function is used when the user wants to substitute a device with another one.
     * #substituteDevice
     * @param {object} doc - the new device to substitute with
     */
    const changeSubDevice = (doc) => {
        setSubstituteDevice(doc)
        //setSubstituteDeviceFields([])
        console.log("jdlkamdjakljdmlkasd change sub device", {substituteDeviceFields, doc})
    }

 const consoleData = {
        registers, 
        maintenanceData: maintenanceData(), 
        subData:{
            substituteDoc,
            substituteDevice,
            substituteDeviceFields,
            substituteNewDeviceFields: substituteNewDeviceFields()
        }, 
        deviceFields, 
        checkStatus,
        doneBy,
        nonConformitiesToSave, 
        newDoc, 
        qrCheck,
        nonConformitiesToDuplicate, 
        device, 
        deviceDeadlines, 
        currentTemplateDevice, 
        updateDoc,
        floor: floor(device)
    }
  
    if (loading) return <Loading/>

    return (
        <>
        <VisDiv rules={[deviceIndexPage=="DEVICE"]} className={networkStatus ? "new-device-container" : "new-device-container stop-scroll-refresh" }>
            <div className='title-with-side-icons' style={{marginBottom:"15px"}}>
                <VisDiv rules={[!data?.hideBackButton]}>
                    <BackButton onClick={backButton}/>
                </VisDiv>
                <VisDiv rules={[data?.hideBackButton]}>

                </VisDiv>
                
                <VisDiv 
                    onClick={()=>{
                        if(clientUser(sUser) && facilityClient(client, sUser)) onDoneClick()
                        }} 
                    rules={[!deviceEdit, facilityClient(client, sUser), clientUser(sUser)]} style={{cursor: checkStatus == "DA FARE" && "pointer", display:"flex", justifyContent:"center", alignItems:"center"}}>
                        <CheckIcon 
                            status={checkStatus}
                            trueString={"FATTO"}
                        />                        
                    <p style={{marginLeft:"5px", cursor: checkStatus == "DA FARE" && "pointer", color: checkStatus == "DA FARE" ? "red":"green"}}>{checkStatus == "DA FARE" ? LDB(P, "toCheck") : LDB(P, "checked")}</p>

                </VisDiv>
                <VisDiv className='edit-button-container'>
                    <VisDiv style={{display:"flex"}} rules={[!deviceEdit, facilityClient(client, sUser), clientUser(sUser)]}>
                        <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={()=>editingToggle()}>
                            <FiEdit             
                            size={15}
                            color={"white"}/>
                        </button>
                    </VisDiv>
                </VisDiv>

            </div>
            <TestButton buttonId='2n92fnun' message='copy device id' consoleData={consoleData} copyId={device?._id}/>
            <VisDiv rules={[!device?.qrUrl, !deviceEdit]} style={{marginRight: "30px", width:"45px"}}>
                <ScanQrCode saveCode={assignQr} />
            </VisDiv>
            <VisDiv onClick={unassignQr} rules={[device?.qrUrl, !deviceEdit]} style={{marginRight: "30px", width:"45px", cursor:"pointer"}}>
                <MdOutlineQrCodeScanner size={35} color="red" />
                <div style={{marginTop: "-38px", width: "35px"}}>
                <p style={{color:"red", textAlign:"center", fontSize:"30px"}}>X</p>
                </div>
            </VisDiv>
            <VisDiv rules={[clientUser(sUser), Array.isArray(deviceLogs) && deviceLogs?.filter?.(x=>x?.logType == "check").length>0, !duplicateDevice]} style={{display:"flex", justifyContent:"center", marginTop:"-10px" }}>  
                <VisDiv style={{display:"flex", alignItems:"center"}} rules={[doneBy?.log?.postedBy]}>
                    <UserIcon
                        bypassCurrentUser={true}
                        size={40}
                        name
                        dateText={LDB(P, "lastCheck")}
                        date={doneBy?.date}
                        otherUser={doneBy?.log?.postedBy}
                    />
                    <button
                        type="button"
                        className="remove-item"
                        style={{marginLeft:"20px"}}
                        onClick={() => deleteLog()}
                        >
                        <AiTwotoneDelete/>
                    </button>
                </VisDiv>                     
            </VisDiv>
            {/*DEVICE()*/}
            <ViewEditPresidio
                label={"PRESIDIO"}
                device={device} 
                template={currentTemplate} 
                templateDevice={currentTemplateDevice}
                trackedChanges={trackedChanges}
                setTrackedChanges = {setTrackedChanges}
                setTemplateDevice={setCurrentTemplateDevice}
                setChangingPresidio={setChangingPresidio}
                deviceEdit={deviceEdit}
                errors={allErrors}
                registerTemplate={currentTemplate}       
                //isDuplicate={duplicateDevice}
            />                                 
            {/*LOCATION_FIELDS()*/}  
            <ViewEditFields
                errorCallback={errorCallback}
                fieldMessages={[positionsString()]}
                errors={allErrors}
                trackedChanges={trackedChanges}
                setTrackedChanges = {setTrackedChanges}
                device={device}
                array={currentTemplate?.locations} 
                state={currentLocation} 
                setState={setCurrentLocation} 
                collection={device?.locations}
                deviceEdit={deviceEdit}
                isDuplicate={duplicateDevice}
                currentTemplateDevice={currentTemplateDevice}
                registerTemplate={currentTemplate}               
            />
            {/*INFO_FIELDS()*/}
            <ViewEditFields
                errorCallback={errorCallback}
                errors={allErrors}
                trackedChanges={trackedChanges}
                setTrackedChanges = {setTrackedChanges}
                device={device}
                array={currentTemplate?.fields} 
                state={deviceFields} 
                setState={setDeviceFields} 
                collection={device?.fields}
                deviceEdit={deviceEdit}
                isDuplicate={duplicateDevice}
                currentTemplateDevice={currentTemplateDevice}
                deviceNonConformities={allNonConformities}
                registerTemplate={currentTemplate}
            />
             {/*DATE_FIELDS()*/}
            <ViewEditFields
                errorCallback={errorCallback}
                errors={allErrors}
                device={device}
                array={dates} 
                state={dateFields} 
                setState={setDateFields} 
                trackedChanges={trackedChanges}
                setTrackedChanges = {setTrackedChanges}
                collection={device?.dates}
                deviceEdit={deviceEdit}
                isDuplicate={duplicateDevice}
                currentTemplateDevice={currentTemplateDevice}
                deviceNonConformities={allNonConformities}
                registerTemplate={currentTemplate}
            />
            <VisDiv rules={[substitutionStatus]}>
                <ViewLabelValueField 
                    label={LDB(P, "deviceStatus")}
                    value={statusTranslation(substitutionStatus)}
                />
            </VisDiv>

             <VisDiv rules={[deviceEdit, currentTemplateDevice]}>
                <VisDiv>
                <div className='bottom-button' style={{width: "200px"}}>
                    <button type="button" style={{backgroundColor: subColor}} className="btn" onClick={substitute} >{LDB(P, "toSubstitute")}</button>
                </div>

                <div className='bottom-button' style={{width: "200px"}}>
                    <button type="button" style={{backgroundColor: supplyColor}} className="btn" onClick={supply} >{LDB(P, "toSupply")}</button>
                </div>
                </VisDiv>

             </VisDiv>
             
             <VisDiv rules={[ substitutionStatus == "DA SOSTITUIRE" || substituteDevice || substituteDeviceFields?.length>0 || substituteReason?.label, ( deviceStatus !== "DA FORNIRE") ]}>
                    <div className='new-device-container-top' style={{marginTop:"18px", marginBottom:"18px"}}>
                        <h2>DA SOSTITUIRE CON DIVERSO PRESIDIO</h2>
                        <VisDiv rules={[deviceEdit]}>
                            <p>SE LASCIATO VUOTO, SOSTITUISCE CON LO STESSO PRESIDIO. CON IL MOTIVO SOSTITUZIONE VUOTO, DI DEFAULT SARA' SCADUTO O ADEGUAMENTO </p>
                        </VisDiv>
                    </div>
                    <ViewEditPresidio
                        label={"PRESIDIO"}
                        device={device ? device : newDoc} 
                        template={currentTemplate} 
                        templateDevice={substituteDevice}
                        trackedChanges={subTrackedChanges}
                        setTrackedChanges = {setSubTrackedChanges}
                        setTemplateDevice={changeSubDevice}
                        substitute={true}
                        deviceEdit={deviceEdit}
                        errors={allErrors}
                        registerTemplate={currentTemplate}       
                        //isDuplicate={duplicateDevice}
                    />
                    <ViewEditFields
                        errorCallback={errorCallback}
                        errors={allErrors}
                        device={device ? device : newDoc}
                        array={substituteFieldsProperties} 
                        trackedChanges={subTrackedChanges}
                        setTrackedChanges = {setSubTrackedChanges}
                        state={substituteDeviceFields} 
                        setState={setSubstituteDeviceFields} 
                        collection={device?.substituteFields}
                        deviceEdit={deviceEdit}
                        isDuplicate={duplicateDevice}
                        currentTemplateDevice={substituteDevice ? substituteDevice : currentTemplateDevice}
                        deviceNonConformities={allNonConformities}
                        registerTemplate={currentTemplate}
                        substitute={true}
                     
                    />

                    <VisDiv rules={[deviceEdit]}>
                    <NewDeviceField label={LDB(P, "subReason")}>
                        <FieldDropdown
                            isSearchable="isSearchable"
                            initialValue={substituteReason}
                            //placeHolder={match ? match : undefined}
                            options={subReasons}
                            onChange={(value) => { 
                                setSubstituteReason(value)
                                const trackData = {trackedChanges: subTrackedChanges, updatedValue: value, oldDoc: device?.substituteReason, fieldName:"MOTIVO SOSTITUZIONE"}
                                trackDoc(trackData, setSubTrackedChanges)

                            }}
                        />
                    </NewDeviceField>
                    </VisDiv>
                    <VisDiv rules={[substitutionStatus == "DA SOSTITUIRE", !deviceEdit, substituteReason?.label ]}>
                        <ViewLabelValueField 
                            label={LDB(P, "subReason")}
                            value={substituteReason?.label}
                            valueType={"string"}
                        />
                    </VisDiv>
                    
                </VisDiv>

            <VisDiv rules={[!deviceEdit]}>
                <ListaNonConformita
                    register = {register}
                    device={device}
                    deviceTemplate={currentTemplateDevice}
                    nonConformityArray={allNonConformities}
                    filter={(x)=>x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO" }
                    visRules={[allNonConformities]}
                    onClick={()=>setDeviceIndexPage("NONCONFORMITY")}
                    title = {LDB(P, "nonConformities")}
                    titleColor={"red"}
                />  
                <VisDiv rules={[facilityClient(client, sUser), clientUser(sUser)]}>          
                    <AddButton
                    label={LDB(P, "addNonConformity")}
                    onClick={()=>setDeviceIndexPage("ADDNONCONFORMITY")}
                    />
                </VisDiv>
                <VisDiv rules={[deviceDeadlines?.checkData?.exists]}>
                    <VisDiv className='new-device-container-top' style={{marginTop:"18px", marginBottom:"18px", color:"red"}}>
                        <h2>{LDB(P, "deadlines")}</h2>
                    </VisDiv>
                    { deviceDeadlines?.deadlines }
                </VisDiv>                   
                <VisDiv className='new-device-container-top' style={{marginTop:"18px", marginBottom:"18px", color:"red"}}>
                    <VisDiv rules={[maintenanceData()?.length > 0]}>
                        <h2 style={{color:"red"}}>{LDB(P, "maintenance")}</h2>
                    </VisDiv>
                    <VisDiv rules={[maintenanceData().length>0]} className='new-device-container-top' style={{marginTop:"15px", marginBottom:"15px"}}>
                        {!Array.isArray(maintenanceData()) ? [] : maintenanceData()?.map?.((item, index)=>{
                            const onNonConformityClick = () => {
                                updateMaintenanceDate({nonConformityTemplate: item, currentTemplate: currentTemplate, dateFields: dateFields, register, networkStatus, sUser, device, registers, replaceDevice: replaceDevice, offlineFn: offlineFn,})
                            }
                            const translatedLabel = (label) => {
                                if(label == "SCADUTO SOSTITUIRE") return LDB("fields", "expired")
                                return label
                            }
                            return(
                                <div key={item?._id ? item?._id : index} className='nonConformity-pin-container-noclick' style={{marginTop:"15px", padding:"5px"}}>   
                                    <div className='vlfield-value-container' style={{display:'flex', textAlign:'left', flex:9}}>
                                        {translatedLabel(item?.label)}
                                    </div>
                                    <VisDiv rules={[facilityClient(client, sUser), clientUser(sUser)]} onClick={onNonConformityClick}>
                                        <TextHighlight highlight={"green"} pointer={true}>
                                            {LDB("misc", "changeDate")}
                                        </TextHighlight>
                                    </VisDiv>
                                </div>
                            )
                        })}
                    </VisDiv>
                </VisDiv>
                <VisDiv>
                    <Photos
                        destination={device} 
                        saveFn = {insertPicture}
                        saveSanityFn={insertPictureSanity}
                    />
                </VisDiv>
                <VisDiv>
                    <Comments
                        destination={device}
                        editFn = {editComment}
                        device = {device} 
                    />
                </VisDiv>


                <VisDiv rules={[clientUser(sUser)]}>
                    <ListaNonConformita
                        register = {register}
                        device={device}
                        nonConformityArray={allNonConformities}
                        deviceTemplate={currentTemplateDevice}
                        onClick={()=>setDeviceIndexPage("NONCONFORMITY")}
                        filter={(x)=>x?.status=="COMPLETATO"}
                        visRules={[allNonConformities]}
                        linkTo={'/non-conformity'}
                        title = {LDB(P, "completedNonConformities")}
                    /> 
                    <ListaNonConformita
                        register = {register}
                        device={device}
                        nonConformityArray={allNonConformities}
                        deviceTemplate={currentTemplateDevice}
                        filter={(x)=>x?.status=="ARCHIVIATO"}
                        onClick={()=>setDeviceIndexPage("NONCONFORMITY")}
                        visRules={[allNonConformities]}
                        linkTo={'/non-conformity'}
                        title = {LDB(P, "archivedNonConformities")}
                    />
                </VisDiv>
            </VisDiv>  
      
            <VisDiv rules={[deviceEdit, currentTemplateDevice, facilityClient(client, sUser), clientUser(sUser)]} className='bottom-buttons' >
                <div className='bottom-button'>
                    <button type="button" style={{backgroundColor: saveButtonColour}} className="btn" onClick={()=>saveDevice()} disabled={errorFound} >{duplicateDevice ? LDB("misc", "duplicate") : LDB("misc", "save")}</button>
                </div>
                <Divider/>
                <VisDiv rules={[duplicateDevice, currentTemplate?.multipleDuplicates]}>
                    <TextField
                        defaultValue={2}
                        onChange={(e) => {
                            setNTimes(+e.target.value) 
                        }}
                    />
                    <button type="button" style={{backgroundColor: saveButtonColour}} className="btn" onClick={()=>duplicateNTimes()} disabled={errorFound} >{LDB("misc", "saveMore")}</button>
                </VisDiv>
                <div className='bottom-button'>
                    <button type="button" style={{backgroundColor:"grey"}} className="btn" onClick={cancel} >{LDB("misc", "cancel")}</button>
                </div>
            </VisDiv>
            <VisDiv className="bottom-buttons" rules={[isSubButtonVisible(), !duplicateDevice]} >
                <div className='bottom-button'>
                    <button type="button" style={{backgroundColor: "blue"}} className="btn" onClick={()=>substituteDeviceFn()}>{LDB(P, "subDevice")}</button>
                </div>
            </VisDiv>
            <VisDiv className="bottom-buttons" rules={[facilityClient(client, sUser), clientUser(sUser),!deviceEdit, device?.status == "DA FORNIRE", !duplicateDevice]} >
                <div className='bottom-button'>
                    <button type="button" style={{backgroundColor: "blue"}} className="btn" onClick={()=>supplyDeviceFn()}>{LDB(P, "supplyDevice")}</button>
                </div>
            </VisDiv>
            <VisDiv rules={[!deviceEdit, device?.status !== "ARCHIVIATO", facilityClient(client, sUser), clientUser(sUser)]}className='bottom-buttons'>
                    <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>archiveDevice()}>{LDB(P, "archiveDevice")}</button>
            </VisDiv>
            <VisDiv rules={[!deviceEdit, device?.status == "ARCHIVIATO", facilityClient(client, sUser), clientUser(sUser)]}className='bottom-buttons'>
                    <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>restoreDevice()}>{"RIPRISTINA"}</button>
            </VisDiv>
            <VisDiv rules={[clientUser(sUser), deviceLogs?.length>0, !deviceEdit, !duplicateDevice]} style={{display:"flex", justifyContent:"left", flexDirection:"column" }}>  
                <VisDiv style={{display:"flex", marginTop:"20px", justifyContent:"center"}}>     
                    <h2>{LDB(P, "logs")}</h2>
                </VisDiv>   
                    <div>
                        <HistoryLogs userLogList={expandedDevice?.userLog}/>
                    </div>                     
            </VisDiv>
        </VisDiv>
        <VisDiv rules={[deviceIndexPage=="ADDNONCONFORMITY"]}><AddNonConformity data={{currentTemplate, nonConformities}} device={device} register={register} saveFn={addNonConformities}/></VisDiv>
        <VisDiv rules={[deviceIndexPage=="NONCONFORMITY"]}><NonConformity data={{client, site, customerUsers, nonConformities}} deleteFn={deleteNonConformity} device={device} register={register} saveFn={updateNonConformity}/></VisDiv>
    </>
    )
}

export default AddNewDevice




/**
 * Component for displaying a list of logs
 * #historyLogs
 * @param {Object} userLogList - list of logs to display
 * @returns {JSX.Element} The list of logs component
 */
export const HistoryLogs = ({userLogList}) => {

    return !Array.isArray(userLogList) ? [] : userLogList?.map?.((log)=>{
        //console.log(log)
        return(
        <div key={log?._key} >
            <HistoryLog log={log}/>
        </div>    

        )
    })
        
    
}

/**
 * Component for displaying a single log
 *  #historyLogs
 * @param {Object} log - the log object being displayed
 * @returns {JSX.Element} The log component
 */
export const HistoryLog = ({log}) => {

    const [viewTracking, setViewTracking] = useState(false)
    const trackingList = log?.historyDevice?.trackingList
    return(
        <>
            <VisDiv style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                <TestButton buttonId={"ajslasmkl"} message={"test log"} consoleData={log} />
                <UserIcon
                    size={40}
                    name
                    dateText={log?.logType?.toUpperCase()}
                    date={log?.date}
                    otherUser={log?.postedBy} 
                    bypassCurrentUser={true}    
                />
                <VisDiv style={{marginLeft:"10px", cursor: "pointer"}} rules={[log?.latitude]}>
                    <a href={gMapLink(log?.longitude, log?.latitude)} target='_blank'>
                        <FiMapPin color={"#324d67"} size={20}/>
                    </a>
                </VisDiv>
                <VisDiv style={{marginLeft:"10px", cursor: "pointer"}} rules={[log?.scannedWithQr]}>
                        <MdOutlineQrCodeScanner color={"#324d67"} size={22}/>
                </VisDiv>
                <VisDiv onClick={()=>setViewTracking(!viewTracking)} rules={[trackingList?.length>0]} style={{marginLeft:"10px", cursor: "pointer"}}>
                    <FiInfo color={"#324d67"} size={20}/>
                </VisDiv>
            </VisDiv>
            <VisDiv style={{marginLeft:"30px"}} rules={[viewTracking]}>
                {!Array.isArray(log?.historyDevice?.trackingList) ? [] : log?.historyDevice?.trackingList?.map?.((item,index)=>{
                    return(
                        <div key={index}>
                            <p style={{fontSize:"12px", color:"grey"}}> {item?.trackString}</p>
                        </div>
                       
                    )
                })}
            </VisDiv>
        </>

    )
}

/**
 * Updates maintenance date fields for devices based on non-conformity templates
 * Handles special cases like quinquennial inspections that update multiple date fields
 * Manages current date assignment and field filtering for date updates
 * #devices
 * #deadlines
 * @param {Object} params Configuration object for maintenance date update
 * @param {Object} params.nonConformityTemplate Non-conformity template defining date requirements
 * @param {boolean} params.networkStatus Current network connectivity status
 * @param {Object} params.currentTemplate Current register template containing date field definitions
 * @param {Array} params.dateFields Current device date fields array
 * @param {Object} params.register Register object containing the device
 * @param {Object} params.sUser Current user object for logging
 * @param {Object} params.device Device object to update
 * @param {Array} params.registers Array of all registers for offline handling
 * @param {Function} params.replaceDevice Function to update device in online mode
 * @param {Function} params.offlineFn Function to handle offline updates
 */
export const updateMaintenanceDate = ({nonConformityTemplate, networkStatus, currentTemplate, dateFields, register, sUser, device, registers, replaceDevice=()=>{}, offlineFn=()=>{},})=>{
    const currentDateinField = (templateField) => {
        
        //const yearsList = templateField?.lists?.find?.(z=>z?.listName == "ANNI")
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth()
        //const thisYearObject = yearsList?.fieldList?.find?.(y => y?.label == currentYear)
        const dateField = {
            _key: keyId(), 
            values:[{
                dateObject:{
                    year: currentYear,
                    month: currentMonth + 1 
                },
                value: currentYear?.toString(),
                 _key: keyId() }], 
            templateField: {_type: "reference", _ref:templateField?._id, _key: keyId()}
        }
        return dateField
    }
    const findFieldInRegisterTemplate = !Array.isArray(currentTemplate?.dates) ? undefined : currentTemplate?.dates?.find?.(x=>x?.nonConformities?.some?.(y=>y?._id == nonConformityTemplate?._id))

    const findField = !Array.isArray(dateFields) ? undefined : dateFields?.find?.(x=>x?.templateField?._ref == findFieldInRegisterTemplate?._id)
    const newDate = currentDateinField(findFieldInRegisterTemplate)

    //IF IS QUINQUENNAL
    const annualTestField = !Array.isArray(dateFields) ? undefined : dateFields?.find?.(x=>x?.templateField?._ref == "df6c2f10-548b-43d5-a8eb-86c4aef56cbf")
    const isFieldQuinquenal = findFieldInRegisterTemplate?._id == "8da7d159-0b11-4477-882c-5e8774f8bbe8"
    const newAnnualDate = currentDateinField({_id: "df6c2f10-548b-43d5-a8eb-86c4aef56cbf"})
    const filteredQuinquennalDateFields = !isFieldQuinquenal ? dateFields : dateFields?.filter?.((x)=>x?.templateField._ref !==  findField?.templateField?._ref && x?.templateField._ref !==  annualTestField?.templateField?._ref)
    const newQuinquennalDatesArray =  [...!Array.isArray(filteredQuinquennalDateFields) ? [] : filteredQuinquennalDateFields, newDate, newAnnualDate]

    const filteredDateFields = !findField ? dateFields : dateFields?.filter?.((x)=>x?.templateField._ref !==  findField.templateField?._ref)
    const newDatesArray =   [...!Array.isArray(filteredDateFields) ? [] : filteredDateFields, newDate]
    //console.log("UPDATED DATES",newDatesArray)
    const datesDoc = {...objectIsObject(device), dates: (!isFieldQuinquenal) ? newDatesArray : newQuinquennalDatesArray}
    const queryDoc = {
        id: register?._id, 
        key: findKey(register, datesDoc),
        doc: addLogToDoc(sUser,datesDoc,"dateUpdated"
        ),

    
    }
         if(!networkStatus) {
        //console.log("OFFLINE")
        offlineFn(queryDoc, registers)
    }
    else{
     replaceDevice(queryDoc)
     //console.log("lkasmdlkasmdalskmd", queryDoc, {isFieldQuinquenal,annualTestField,newAnnualDate})
    }
    //GIVEN THE DATE NON CONFORMITY TEMPLATE, RETURNA AN ARRAY OF DATES UPDATED WITH TODAY DATE: NOW NEED TO UPDATE THE DOC WITH THE NEW ARRAY OF DATES
    

}
